import { Fragment } from "react";
import styles from "./Breadcrumbs.module.scss";
import Link from "next/link";
import { getCategoryLinkAttributes } from "grandus-lib/hooks/useFilter";
import { get, map } from "lodash";

const Breadcrumbs = ({ current = "", data, options = {} }) => {
  return (
    <div className={styles.wrapper}>
      <div className="breadcrumbs hidden-md-down">
        <ul>
          {get(options, "hideHomeItem") ? (
            ""
          ) : (
            <li>
              <Link href={"/"}>
                <a href="#">
                  <i className="fas fa-home" aria-hidden="true"></i>
                </a>
              </Link>
            </li>
          )}
          {map(get(data, "categorical", []), (entry) => {
            return (
              <Fragment key={`breadcrumbs-categorical-${get(entry, "id")}`}>
                <li className="sep">
                  <i className="fas fa-chevron-right" aria-hidden="true"></i>
                </li>
                <li>
                  <Link
                    {...getCategoryLinkAttributes(get(entry, "urlName"))}
                    scroll={true}
                  >
                    <a>{get(entry, "name")}</a>
                  </Link>
                </li>
              </Fragment>
            );
          })}

          {map(get(data, "childrens", []), (entry, index) => {
            return (
              <Fragment key={`breadcrumbs-child-${index}`}>
                <li className="sep">
                  <i className="fas fa-chevron-right" aria-hidden="true"></i>
                </li>
                <li>
                  <Link
                    href={get(entry, "href")}
                    scroll={true}
                  >
                    <a>{get(entry, "name")}</a>
                  </Link>
                </li>
              </Fragment>
            );
          })}
          {current ? (
            <Fragment>
              <li className="sep">
                <i className="fas fa-chevron-right" aria-hidden="true"></i>
              </li>
              <li>{current}</li>
            </Fragment>
          ) : (
            ""
          )}
        </ul>
      </div>
    </div>
  );
};

export default Breadcrumbs;
